module.exports = __webpack_public_path__ + "medaln-b16cc387.webp";